import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import NotificationBloc from '@components/common/NotificationBloc/NotificationBloc';
import { DoubleAuthenticationModel } from '@models/UserModel/DoubleAuthenticationModels/DoubleAuthenticationModel';

import css from './FeedBack.module.scss';

type FeedBackPropsType = {
    submissionState: {
        error: string;
        type: number;
        retries: number;
        isFeedBackVisible: boolean;
    };
    onHideFeedBack: () => void;
    useBackUpCodes?: boolean;
    onUseBackUpCodes?: () => void;
};

const FeedBack = ({ submissionState, onHideFeedBack, onUseBackUpCodes, useBackUpCodes }: FeedBackPropsType) => {
    const { t } = useTranslateLpc(['lpc-authentication', 'common']);

    const renderMessage = () => {
        if (submissionState.type === DoubleAuthenticationModel.SMS) {
            return (
                <>
                    {t('login-confirmation.submission-sms-failure', { count: submissionState.retries })}
                    {useBackUpCodes && (
                        <>
                            <br />
                            <br />
                            {t('login-confirmation.submission-tfa-failure-1')}
                            <a onClick={onUseBackUpCodes}>{t('login-confirmation.click-here')}</a>
                            {t('login-confirmation.submission-tfa-failure-2')}
                        </>
                    )}
                </>
            );
        }

        if (useBackUpCodes) {
            return (
                <>
                    {t('login-confirmation.submission-tfa-failure-1')}
                    <a onClick={onUseBackUpCodes}>{t('login-confirmation.click-here')}</a>
                    {t('login-confirmation.submission-tfa-failure-2')}
                </>
            );
        }

        return <>{t('login-confirmation.submission-google-failure')}</>;
    };

    return (
        <div
            style={{ visibility: submissionState.isFeedBackVisible ? 'visible' : 'hidden' }}
            className={`${css.feedback} ${!submissionState.error ? css.feedback_success : css.feedback_failure}`}
        >
            {!submissionState.error ? (
                <NotificationBloc
                    customClass={css.feedback}
                    variant={'success'}
                    message={t('login-confirmation.submission-success')}
                    onResetVisibility={() => onHideFeedBack()}
                />
            ) : (
                <NotificationBloc
                    customClass={css.feedback}
                    variant={'warning'}
                    message={renderMessage()}
                    onResetVisibility={() => onHideFeedBack()}
                />
            )}
        </div>
    );
};

export default FeedBack;
